import React, { useState, useMemo } from "react";
import styled from "styled-components";
import Modal from "../../../Kanban/Modal/Modal";
import FormikInput from "../../../Formik/FormikInput";
import { useFormikContext } from "formik";
import { Form } from "react-router-dom";
import CreateBranch from "../../CreateBranch/CreateBranch";
import { useLanguage } from "../../../LangTranslation/LanguageContext";

// import CreateNewContact from './ContractAndAddresesModals/CreateNewContact';

const TableContainer = styled.div`
  margin: 20px !important;
  width: 100%;
  background-color: #fff;
  border-radius: 15px;
  padding: 20px;
  overflow: auto;
  .table tbody tr td,
  .table thead tr {
    padding: 21px !important;
    font-family: "Inter", sans-serif;
    border-bottom: 0px !important;
    font-weight: 600;
  }

  .table th {
    background-color: #f8f9fa !important;
    padding: 15px !important;
    color: #4e5d78 !important;
    font-family: "Inter", sans-serif;
    font-size: 16px;
  }

  tbody tr:hover {
    background-color: #f4f8ff;
  }
`;

const ActionButton = styled.button`
  border-radius: 10px;
  background-color: #ff5837;
  color: #ffffff;
  family-font: "Inter";
  border: none;
  // width: 80px;
  min-width: 130px;
  height: 35px;
  margin-right: 20px;
  margin-top: 25px;
`;

const Branches = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { language, translations } = useLanguage();
  const t = translations[language];

  const { setFieldValue, values } = useFormikContext();

  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <TableContainer>
        <table className="table">
          <thead>
            <tr className="heading_row">
              <th>{t["Name"]}</th>
              <th>{t["Street"]}</th>
              <th>{t["City"]}</th>
              <th>{t["Zip"]}</th>
              <th>{t["Phone"]}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>aaaa</td>
              <td>bb</td>
              <td>c</td>
            </tr>
          </tbody>
        </table>
      </TableContainer>

      <ActionButton onClick={openModal}>+ {t["Add Branch"]}</ActionButton>
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <CreateBranch />
       
      </Modal>
    </div>
  );
};

export default Branches;
